export const downloadFileFromUrl = async (fileUrl: string, filename: string) => {
    try {
        const response = await fetch(fileUrl, { mode: "cors" });
        if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.statusText}`);
        }
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.warn("Fetch failed due to CORS. Falling back to direct link open.");
        window.open(fileUrl, "_blank");
    }
};